import type { ComponentType } from 'react';
import { useProjectContextReporter } from '../../services/use-project-context-reporter/index.tsx';
import { useRecentProjectTracker } from '../../services/use-recent-project-tracker/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Trackers: ComponentType<Record<any, any>> = () => {
	useProjectContextReporter();
	useRecentProjectTracker();

	return null;
};

export default Trackers;
